module.exports = __webpack_public_path__ + "static/img/section3.af0f7ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cooperativePartner/section3.png
// module id = 612
// module chunks = 12